import React, {useState} from 'react';
import { Link } from 'react-router-dom';

const ScrollButton = () =>{

const [visible, setVisible] = useState(false)

const toggleVisible = () => {
	const scrolled = document.documentElement.scrollTop;
	if (scrolled > 300){
	setVisible(true)
	}
	else if (scrolled <= 300){
	setVisible(false)
	}
};

const scrollToTop = () =>{
	window.scrollTo({
	top: 0,
	behavior: 'smooth'
	/* you can also use 'auto' behaviour
		in place of 'smooth' */
	});
};

window.addEventListener('scroll', toggleVisible);

return (
	<div onClick={scrollToTop} >
		<Link to='#top' aria-label='Scroll Up' id='scrollUp' style={{position:'fixed',zIndex:1000, display: visible ? 'inline' : 'none'}}><i className="fas fa-level-up-alt"></i></Link>
	</div>
);
}

export default ScrollButton;
